import { Cookies } from 'react-cookie';

const cookies = new Cookies();

export const getCookie = (cookieName) => {
  const val = cookies.get(cookieName, { path: '/' });
  if (val === 'undefined' || !val) {
    return null;
  }
  return val;
};

export const clearCookies = () => {
  cookies.remove('IdToken', { path: '/' });
  cookies.remove('RefreshToken', { path: '/' });
  cookies.remove('AccessToken', { path: '/' });
};

export const saveBrowserCheckCookie = (wasChecked) => {
  cookies.set('wasBrowserChecked', wasChecked, { path: '/' });
};

export const getBrowserCheckCookie = () => {
  const wasBrowserChecked = cookies.get('wasBrowserChecked');
  if (!wasBrowserChecked) {
    return null;
  }
  return wasBrowserChecked;
};

export const saveQueueCookie = (activeQueueId) => {
  cookies.set('activeQueueId', activeQueueId, { path: '/' });
};

export const getUserId = () => {
  const user = cookies.get('user');
  return user ? user._id : null;
};
